import { render, staticRenderFns } from "./Entity.vue?vue&type=template&id=46bfa20a"
import script from "./Entity.vue?vue&type=script&lang=js"
export * from "./Entity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports